import moment from "moment-timezone";

const EXPLICIT_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;

/** Reject offsetless provider times and date-only business values. */
export function parseCanonicalInstant(value?: string | Date | null): Date | null {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (!value || !EXPLICIT_OFFSET.test(value)) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function isSupportedCompanyZone(value: string): boolean {
  return moment.tz.zone(value) !== null;
}

/** Use bundled IANA rules for company display, independent of browser tzdb age. */
export function formatTechnicalInstant(
  value: string | Date | null | undefined,
  timeZoneId?: string | null,
  locale = "fr",
): string {
  const instant = parseCanonicalInstant(value);
  if (!instant) return "";
  const zone = timeZoneId ? moment.tz.zone(timeZoneId) : null;
  // Intl supplies localization only when a company zone is configured. Never
  // return this wall-clock projection for persistence or duration calculations.
  const display = zone
    ? new Date(instant.getTime() - zone.utcOffset(instant.getTime()) * 60_000)
    : instant;
  return new Intl.DateTimeFormat(locale, {
    timeZone: zone ? "UTC" : undefined,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(display);
}
